import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../DataProviders/AppStateProvider';
import PrimaryButton from '../Buttons/PrimaryButton';
import RenderCondition from '../RenderCondition';
import useDocTitle from '../../Handler/DocTitleHandler';
import RestartButton from '../Buttons/RestartButton';
import Text from '../Text';

/**
 * Arthur-Fischer-Erfinderpreis Quick Check App
 *
 * Step E - Results
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const StepErgebnis = props => {
  // Use the context for global data storage and state management
  const { appData } = useContext(AppContext);
  const { setDocTitle } = useDocTitle();

  // State for the content visibility
  const [ resultPositive, setResultPositive ] = useState(false);

  // Changes the doc title
  useEffect(() => {
    setDocTitle('Ergebnis');
  }, [appData.currentStep]);

  // Decision maker for the results
  useEffect(() => {
    // Alternative to check answers only for finished steps
    const result = Object.values(appData.journeys[appData.currentJourney])
      .filter(step => step.finished)
      .every( step => step.answer);

    setResultPositive(result);
  }, []);

  const handleApplyClick = (e) => {
    e.preventDefault();

    const isPrivatePersonJourney = appData.currentJourney === 'privatePerson';
    let url = "https://bewerbung.erfinderpreis-bw.de/";

    if ( typeof window.AFE_QUICK_CHECK_CONTENTS !== 'undefined' ) {
      url = ( isPrivatePersonJourney ) ? window.AFE_QUICK_CHECK_CONTENTS.steps.result.url : window.AFE_QUICK_CHECK_CONTENTS.steps.result.urlStudents
    }

    window.open(url, "_blank")
  };

  return (<>
    <h2 className="headline headline--2">Ergebnis</h2>

    {/* TRUE */}
    <RenderCondition condition={resultPositive}>
      <div className="text text--afp-quickcheck">
        <Text path="steps.result.true">Ja, Sie erfüllen die Voraussetzungen.<br />
          Wir freuen uns auf Ihre Bewerbung!</Text>
      </div>

      <div className="container__afp-quickcheck-answers">
        {/* Check for global constant to enable or disable the application button */}
        <RenderCondition condition={window.DISABLE_AFE_QUICKCHECK_APPLICATION_BTN}>
          <PrimaryButton onClick={handleApplyClick}>Jetzt bewerben</PrimaryButton>
        </RenderCondition>
      </div>
    </RenderCondition>

    {/* FALSE */}
    <RenderCondition condition={!resultPositive}>
      <div className="text text--afp-quickcheck">
        <Text path="steps.result.false">Leider erfüllen Sie nicht die Voraussetzungen.</Text>
      </div>

      <div className="text text--small text--afp-quickcheck">
        <RestartButton>Neustart</RestartButton>
      </div>
    </RenderCondition>
  </>);
}

export default StepErgebnis;
